export default {
  user: "User",
  users: "Users",
  role: "Role",
  unit: "Unit",
  name: "Name",
  firstName: "FirstName",
  lastName: "Lastname",
  username: "Username",
  password: "Password",
  confirm: "Confirm Password",
  gender: "Gender",
  residential: "Residential",
  nationalCode: "National Code",
  // issuedCountry: 'Issued Country',
  birthCity: "City Of Birth",
  birthProvince: "Province Of Birth",
  otherCode: "Pervasive Code",
  issuedProvince: "Issued Province",
  issuedCity: "Issued City",
  mobile: "Mobile",
  mobiles: "Mobiles",
  anotherMobile: "Another Mobile",
  fathersName: "Father's Name",
  spouseFirstName: "Spouse's first name",
  spouse: "Spouse",
  spouseLastName: "Spouse's last name",
  spouseNationalCode: "Spouse's National Code",
  spouseIdentityCode: "Spouse's Identity Code",
  spouseCountryId: "Spouse's Nationality",
  email: "Email",
  nationality: "Nationality",
  phone: "Phone Number",
  dialCode: "Dial Code",
  internal: "Internal",
  maritalStatus: "Marital Status",
  married: "Married",
  single: "Single",
  referralWay: "Referral Way",
  referrerName: "Referrer Name",
  referrerUser: "Referrer %{user}",
  referrerAddress: "Referrer Address",
  addService: "Add Service",
  userShare: "User Share",
  userTax: "User Tax",
  hospitalShare: "Hospital Share",
  hospitalTax: "Hospital Tax",
  dateOfBirth: " Date Of Birth",
  dateOfMarriage: " Date Of Marriage",
  searchForForeigner: "Search For Foreigner",
  foreignerInfo: "Foreigner Info",
  searchForUser: "search For {User}",
  contact: "Contact",
  forefatherName: "Forefather's Name",
  typeOfIdentificationDocument: "Type Of Identification Document",
  expiryDateOfIdentityDocument: "Expiry Date Of Identity Document",
  spouseJob: "Spouse Job",
  spouseEducationalDegree: "Spouse Educational Degree",
  legalExpertInfo: "Legal Expert Info",
  legalFileNumber: "Legal File Number",
  insuranceNumber: "Insurance Number",
  fileNumber: "File Number",
  doctorInfo: "Doctor Info",
  doctorAccountInfo: "Doctor Account Info",
  nurseAndMidwifeInfo: "Nurse And Midwife Info",
  personalInfo: "Personal Info",
  job: "Job",
  completionDateOfMedicalLicense: "Completion Date Of Medical License",
  medicalSpecialtyId: "Medical Specialty Id",
  medicalScientificDegreeId: "Medical Scientific Degree ",
  officeLicenseNumber: "Office License Number",
  officeLicenseNumberValidation: "Office License Number Validation",
  officePhoneNumber: "Office Phone Number",
  officeAddress: "Office Address",
  statusOfMembership: "Status Of Membership",
  accountNumber: "Account Number",
  iBAN: "iBAN",
  bankId: "Bank",
  accountType: "Account Type",
  cooperationType: "CooperationType",
  contractType: "ContractType",
  description: "Description ",
  dateOfIssueOfTheDocument: "Date Of Issue Of TheDocument",
  fieldOfStudy: "Field Of Study",
  educationalDegree: "EducationalDegree",
  address: "Address",
  descriptionMama: "description Mama ",
  nonFullTime: "Non Full-Time",
  fullTimeGeographical: "Full-Time Geographical",
  fullTime: "Full-Time ",
  guest: "Guest",
  formal: "Formal",
  dateOfGraduation: "Date Of Graduation",
  referralWayRole: {
    doctorsOfTheCountryOfOrigin: "Doctor Of The Origin Country",
    agent: "Agent's Name",
    referralDoctor: "Referral Doctor's Name",
    introducingFriends: "Referral Name",
  },
  socialNetworks: "Social Networks",
  doctorName: "Doctor's Name",
  messageType: "Message Type",
  messageTime: "Message Time",
  messageTimeUnit: "Message Time Unit",
  messageTimeState: "Message Time State",
  messageTimeValue: "Message Time Value",
  message: "Message",
  roles: "Roles",
  units: "Units",
  turnStatus:"Turn Status",
  ReferralStatus:" Referral Status",
  nationalCodeN:"nationalCode",
};
